module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/canva/canva-design-03-6fc764a2a0488efba55b6b71ef6d4792.jpg";